import * as React from 'react';

import { ServiceLocator } from '../../app/ServiceLocator';
import { ConnectedSpaceInfoProvider } from '../../app/spaces/RouterHelpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../app/state/SpaceInfo';
import { Messages } from '../../codegen/Localize';
import { angularProviderHOC } from '../../common/react/AngularProviderHOC';
import { ReactDirectiveProps } from '../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../ts/services/BrowserTitleService';
import { ConnectedHome } from './ConnectedHome';

export interface HomeSpaceProviderOwnProps extends ReactDirectiveProps {}

export interface HomeSpaceProviderPropsFromAngular {
  readonly browserTitleService: BrowserTitleService;
}

export type HomeSpaceProviderProps = HomeSpaceProviderOwnProps & HomeSpaceProviderPropsFromAngular;

export class HomeSpaceProviderComponent extends React.PureComponent<HomeSpaceProviderProps> {
  private HomeSpaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'home',
    subspaceName: undefined
  };

  public render() {
    return (
      <ConnectedSpaceInfoProvider spaceInfo={this.HomeSpaceInfo}>
        <ConnectedHome />
      </ConnectedSpaceInfoProvider>
    );
  }

  public componentDidMount() {
    this.props.browserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.home_browserTitle() });
  }
}

export namespace HomeSpaceProviderAngularProvider {
  function getAngularServicesWithServiceLocator() {
    const browserTitleService = ServiceLocator.get<BrowserTitleService>('BrowserTitleService');
    return {
      browserTitleService,
    };
  }

  function selectPropsFromAngularServices(angularServices: HomeSpaceProviderPropsFromAngular) {
    return angularServices;
  }

  export const HOC = angularProviderHOC<HomeSpaceProviderOwnProps, HomeSpaceProviderPropsFromAngular, HomeSpaceProviderPropsFromAngular>({
    getAngularServicesWithServiceLocator,
    selectPropsFromAngularServices,
  });
}

export const HomeSpaceProvider: React.ComponentType<HomeSpaceProviderOwnProps>
  = HomeSpaceProviderAngularProvider.HOC(HomeSpaceProviderComponent);
